import { gql } from '@apollo/client'
import React from 'react'

import { serviceOrdersClient } from '../../../../utils/apollo/api'
import { useQuery } from '../../../../utils/apollo/_helpers/useQuery'
import StatePresenter from '../../../../components/helpers/StatePresenter'
import { useServiceOrder } from './ServiceOrderLoader'

const Context = React.createContext([])
const { Provider } = Context
const useServiceOrderState = () => React.useContext(Context)
export const useParentServiceOrder = () => useServiceOrderState()?.serviceOrder

const QUERY = gql`
  query ServiceOrder($id: ID, $permalinkToken: String) {
    serviceOrder(id: $id, permalinkToken: $permalinkToken, filter: { includeDeleted: true, ignoreSegments: true }) {
      id
      name
      yearlyId
      startDate
      endDate
      deleted
      insertedAt
      updatedAt
      metadata
      formReplyId
      parentId
      address {
        search
        complement
      }
      fieldValues {
        id
        value
        fieldId
        field {
          id
          name
          type
        }
      }
      scheduling
      customerCode
      internalCode
      invoice
      description
      user {
        id
        name
      }
      placeId
      place {
        id
        name
        resume
        type
        fieldValues {
          id
          value
          field {
            id
            name
            type
          }
        }
      }
      checklist {
        id
        name
        questions {
          id
          name
          reference
          parentReference
          data
          displayConditions
          ordination
          categoryOrdination
          required
          allowNull
          data
          documents {
            id
            src
            type
            description
            __typename
          }
          description
          photosEnabled
          photosRequired
          notesEnabled
          notesRequired
          defaultValue
          options {
            id
            name
            reference
            ordination
            __typename
          }
          masks {
            id
            name
            pattern
            __typename
          }
          category {
            id
            name
            __typename
          }
          type {
            id
            name
            __typename
          }
          __typename
        }
      }
      replies {
        id
        value
        notes
        questionId
        insertedAt
        isNonCompliance
        blockIndex
        documents {
          id
          src
          type
          description
        }
        question {
          id
          name
          data
          ordination
          categoryOrdination
          nonComplianceConditions
          documents {
            id
            src
            type
            description
          }
          description
          reference
          parentReference
          type {
            id
            name
          }
          category {
            id
            name
          }
        }
      }
    }
  }
`

const ParentServiceOrderLoader = ({ children, id }) => {
  const { parentId } = useServiceOrder()
  let { data, ...state } = useQuery(QUERY, {
    variables: { id: parentId ?? id },
    client: serviceOrdersClient
  })

  return (
    <StatePresenter {...state} empty={!data?.serviceOrder}>
      <Provider value={data}>{children}</Provider>
    </StatePresenter>
  )
}

export default ParentServiceOrderLoader
